import { render, staticRenderFns } from "./SidebarLayout3.vue?vue&type=template&id=3a5d426e&scoped=true&"
import script from "./SidebarLayout3.vue?vue&type=script&lang=js&"
export * from "./SidebarLayout3.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLayout3.vue?vue&type=style&index=0&id=3a5d426e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d426e",
  null
  
)

export default component.exports